<template>
  <div class="rating-input">
    <NuxtRating
      :rating-size="44"
      :rating-step="1"
      :read-only="false"
      :rating-value="ratingValue"
      active-color="#fbbd09"
      @rating-selected="onRatingSelected"
    />
    <p v-if="undefined !== errors" class="rating-input__error">
      <template v-for="error in errors">
        {{ error }}
      </template>
    </p>
  </div>
</template>

<script setup>
import { FORM_INJECTION_KEY } from "~/nuxt_modules/common/constants/index.js";

const ratingValue = defineModel({ default: 0, required: true });

const props = defineProps({
  name: { type: String, required: true },
});

/*
Получаем набор ошибок с формы и достаем их по ключу(name) инпута.
validateField - для запуска валидации текущего инпута
 */
const { errors: formErrors, validateField } = inject(FORM_INJECTION_KEY);
const errors = computed(() => {
  return formErrors?.value[props.name];
});

function onRatingSelected(rating) {
  ratingValue.value = rating;
  validateField(props.name);
}
</script>

<style scoped lang="scss">
.rating-input {
  @include flex-container(column, flex-start);
  gap: 16px;

  &__error {
    @include font(12, 16);
    color: var(--color-red-error-500);

    padding-inline: 8px;
  }
}
</style>
